import paymentsReducers from './reducers'

export { default as paymentsTypes } from './types'
export { default as paymentsActions } from './actions'
export { default as paymentsSelectors } from './selectors'

export default paymentsReducers
